import { Create } from "react-admin";
import { BankForm } from "./Form";

export function PayerBankCreate() {
  return (
    <Create redirect="list">
      <BankForm />
    </Create>
  );
}
